import { render, staticRenderFns } from "./YearTrend.vue?vue&type=template&id=54aaaa32&scoped=true&"
import script from "./YearTrend.vue?vue&type=script&lang=js&"
export * from "./YearTrend.vue?vue&type=script&lang=js&"
import style0 from "./YearTrend.vue?vue&type=style&index=0&id=54aaaa32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aaaa32",
  null
  
)

export default component.exports